import { Component, OnInit, Input, Injectable, Inject, ViewChild, Output } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subject } from 'rxjs/Subject';
import { MatPaginatorIntl } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, Response } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { EnvironmentProvider } from '../../core/browser-providers';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { Environment } from '../../../environments/enviroment.model';
import { TranslateService } from '../../core/translate.service';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { MediaService } from '../../shared-services/media.service';
import { Subscription } from 'rxjs/Subscription';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { GenericListComponent, Page, HasAction, Actions } from '../../shared-components/generic-list/generic-list.component';
import { SecurityService } from '../../security/security.service';
import { CategoriaProducto } from './categoria-producto.model';


interface Filters {
  description: string;
  page: number;
  size: number;
  search?: string;
}

@Component({
  selector: 'app-categoria-producto-list',
  templateUrl: './categoria-producto-list.component.html',
  styleUrls: ['./categoria-producto-list.component.scss']
})
@Injectable()
export class CategoriaProductoListComponent implements OnInit {

  // @Output() subtitle = 'Listado';

  private backendUrl: string;

  private filters: Filters = {
    description: undefined,
    page: 0,
    size: 10,
  };

  columns = [
    { name: 'description',  label: 'Descripción' },
    { name: 'descripcionActivo',  label: 'Estado' },
    { name: 'categoriaPadreNombre',  label: 'Categoría Padre' }
  ];

  public showFilters = true;
  isMobile: boolean;

  @ViewChild(GenericListComponent)
  private genericListComponent: GenericListComponent;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  public hasActions: HasAction;

  filtersActive = false;
  mostrarResumen = false;
  isLoading = false;

  filtersLoaded = false;
  subscriptions: Subscription[] = [];

  itemsList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const categoriasPromise = this.backendService.get(CategoriaProducto, CategoriaProducto.path + "all-with-padres", filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const categorias = await categoriasPromise;
        return categorias;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.filtersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<CategoriaProducto[]>;

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    private snackService: SnackService,
    private traslateService: TranslateService,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    private http: Http,
    public securityService: SecurityService,
    private dialogService: DialogService,
  ) {
    this.backendUrl = env.endpoints.api + '/backend';
  }

  ngOnInit() {
    this.showFilters = true;
    this.filtersLoaded = true;

    this.hasActions = new HasAction();

    this.hasActions.hasAction = true;
    this.hasActions.actions = [{ 'element': Actions.edit, 'permission': 'EDITAR_CATEGORIA_PRODUCTO'},
                              { 'element': Actions.delete, 'permission': 'ELIMINAR_CATEGORIA_PRODUCTO'}];

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
      this.showFilters = !this.isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    this.itemsList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refreshItemsList();
  }


  refreshItemsList() {
    this.itemsList.next(this.getFilters());
  }

  getDefaultFilters() {
    this.filters = {
      description : undefined,
      page: 0,
      size: 10,
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refreshItemsList();
  }

  onSearch(searchText) {
    this.filters.search = 'description:' + searchText;
    this.refreshItemsList();
  }

  clearSearch() {
      this.refreshItemsList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  displayFilters(boolean: boolean) {
    this.showFilters = boolean;
  }

  onAdd() {
    this.router.navigate(['/categorias/agregar']);
  }


  onEdit(role: any) {
    this.router.navigate(['/categorias/editar', role.id]);
  }


  async onDelete(categoria: any) {

    this.dialogService.confirm('Eliminar Categoria',
    '¿Está seguro que desea eliminar las categorias ' + categoria.description + '?')
    .then( res => {
      if (res) {
        this.deleteCategoria(res, categoria);
      }
    });

  }

  async deleteCategoria(res, categoria: CategoriaProducto) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.delete(CategoriaProducto.path + categoria.id);
        this.snackService.success('Categorías de Productos eliminadas correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
        this.refreshItemsList();
      }

    }

  }

  onFiltersChanged(event) {
    this.refreshItemsList();
  }

  removeChip(event) {
    this.refreshItemsList();
  }

}



// WEBPACK FOOTER //
// ./src/app/productos/categoria-producto/categoria-producto-list.component.ts